import React from 'react';
import {
    Button,
    Checkbox,
    FormControlLabel,
} from '@mui/material';

function Step5() {
    return (
        <>
            <div className="form">
                <h3 className="hd_6">Final Confirmation</h3>
                <div className="form">
                    <div className="gap_p">
                        <div className="control_group w_100">
                            <FormControlLabel control={<Checkbox defaultChecked />} label="I understand that closing my store will make it invisible to customers and stop new orders" />
                        </div>
                       
                    </div>
                </div>

            </div>
        </>
    );
}

export default Step5;
